import React, { Component } from 'react';
import { string, element, func, bool, oneOfType, shape, any } from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import cx from 'classnames';
import styles from './styles.scss';
import { withStyles } from '@material-ui/core/styles';

const dialogStyles = {
  dialog: {
    maxWidth: '475px',
    margin: '48px'
  },
  dialogContentText: {
    color: '#2A323C',
    marginBottom: '0px'
  }
};

export class BasePromptDialog extends Component {
  static propTypes = {
    open: bool.isRequired,
    content: oneOfType([string, element]),
    title: string,
    displayCloseBtn: bool,
    leftButtonLabel: string,
    rightButtonLabel: string,
    onClose: func.isRequired,
    onLeftBtnClick: func.isRequired,
    onRightBtnClick: func.isRequired,
    classes: shape({ any })
  }

  static defaultProps = {
    title: 'Title',
    content: 'Content goes here',
    leftButtonLabel: 'CANCEL',
    rightButtonLabel: 'PROCEED',
    displayCloseBtn: true
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  }

  render() {
    const {
      title,
      content,
      displayCloseBtn,
      leftButtonLabel,
      rightButtonLabel,
      onLeftBtnClick,
      onRightBtnClick,
      open,
      classes,
    } = this.props;

    return (
      <div className={styles.container}>
        <Dialog
          data-test="basePromptDialog"
          open={open}
          maxWidth={false}
          classes={{
            paper: styles.container
          }}
          PaperProps={{ className: classes.dialog }}
        >
          <DialogTitle className={cx(styles.defaultTitle, {[styles.title]: title})}>
            {title}
            {displayCloseBtn && <IconButton aria-label="close" className={styles.closeButton} onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>}
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <DialogContentText className={classes.dialogContentText}>
              {content}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={styles.actions}>
            <Button data-test="basePromptDialogLeftBtn" onClick={onLeftBtnClick} color="secondary" className={styles.button}>
              <Typography variant="body2" className={styles.buttonText}>
                {leftButtonLabel}
              </Typography>
            </Button>
            <Button
              onClick={onRightBtnClick}
              className={styles.button}
              color="primary"
              variant="contained"
            >
              {rightButtonLabel}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(dialogStyles)(BasePromptDialog);